import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { PlantsService } from '@cemex-core/cmx-api';
import {
  LOAD_SALES_AREA_SUCCESS,
  LoadJobsitePlantFail,
  SetJobsitePlant,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { Plant } from '@cemex-core/cmx-api/models/order-management/plant';
import { getJobsiteSalesAreas, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { UnicEffectsAvailableEnum } from '@ordersnproducts/modules/shared/modules/dynamic-effects/deletable-effect-sources.constant';
import { EffectsRegistrationService } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effects-registration.service';

@Injectable()
export class JobsitePlantDefaultEffects {
  plantLoadDefault$: Observable<Action | Action[]> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_SALES_AREA_SUCCESS),
      filter(() => this.isEffectAvailable()),
      switchMap((_) => {
        return this.store.select(getJobsiteSalesAreas).pipe(
          take(1),
          switchMap((state) => {
            if (_safe(() => state[0].plant.plantId)) {
              return this.plantsService.getPlant(_safe(() => state[0].plant.plantId)).pipe(
                map((plant: Plant) => {
                  return new SetJobsitePlant([plant]);
                }),
                catchError((error) => of(new LoadJobsitePlantFail(error))),
              );
            }
            return of(new LoadJobsitePlantFail('Jobsite does not have a plant.'));
          }),
        );
      }),
    ),
  );

  private isEffectAvailable(): boolean {
    return this.effectRegister.isEffectAvailable(UnicEffectsAvailableEnum.JobsitePlantDefaultEffects);
  }

  constructor(
    private actions$: Actions,
    private plantsService: PlantsService,
    private store: Store<OrderBuilderState>,
    private effectRegister: EffectsRegistrationService,
  ) {}
}
